import {DOM} from '../../../../../plugins/levcharity/resources/scripts/helpers/DOM'
import {Helper} from '../../../../../plugins/levcharity/resources/scripts/helpers/Helper'

export class MyAccountParticipantDashboard {
    #dashboardData = {}
    #dashboard
    constructor(){
        this.#dashboard = DOM.el('.chaiathon-dashboard-container');
        if (!this.#dashboard) {
            return;
        }
        this.#fetchData();

        this.#addEvents();
    }



    async #fetchData(){
        const {Helper} = await import('../../../../../plugins/levcharity/resources/scripts/helpers/Helper.js' /* webpackChunkName: "helper" */);

        Helper.request(admin_ajax[0], {
            action: this.#dashboard?.dataset.action,
            token: this.#dashboard?.dataset.token,
        })
            .then((response) => {
                if (response.success) {
                    this.#dashboardData = {
                        participantData: response.participant_data,
                        levelData: response.level_data
                    }
                    this.#renderProfile()
                }
            })
    }

    #renderProfile() {
        const participantData = this.#dashboardData.participantData;
        const levelData = this.#dashboardData.levelData;
        const profileTotalsWrapper = DOM.el('.profile-totals-wrapper');
        const totalDonationsCountWrapper = DOM.el('.total-donations .count-wrapper', profileTotalsWrapper);
        const totalDonationCount = DOM.el('.count', totalDonationsCountWrapper);
        const totalDonorsCountWrapper = DOM.el('.total-donors .count-wrapper', profileTotalsWrapper);
        const totalDonorsCount = DOM.el('.count', totalDonorsCountWrapper);

        const currencySymbol = this.#dashboard.dataset.currencySymbol;

        this.#numberAnimation(participantData.total_amount, totalDonationCount, currencySymbol)
        this.#numberAnimation(levelData.donors_count, totalDonorsCount, '', '', 0, false)

        const progressBar = DOM.el('.profile-progress-bar-wrapper');
        const countWrapper = DOM.el('.count-wrapper', progressBar);
        const nextBadgeCountWrapper = DOM.el('.next-badge-count-wrapper', progressBar);
        const dashboardRestWrapper = DOM.el('.dashboard-rest-wrappper');
        const profileBucksWrappers = DOM.els('.profile-bucks-wrapper');
        this.#numberAnimation(levelData.userNeedToNextLevel, DOM.el('.count', nextBadgeCountWrapper), currencySymbol)
        this.#numberAnimation(levelData.userTotalRaised, DOM.el('.current-count', countWrapper), currencySymbol)
        this.#numberAnimation(levelData.userNextLevel[0]?.amountRange.min, DOM.el('.max-count', countWrapper), currencySymbol);

        profileBucksWrappers.forEach(profileBucksWrapper => {
            this.#numberAnimation(levelData.userCoin, DOM.el('.count', profileBucksWrapper), '', '', 0, false);
        })


    }


    async #numberAnimation(to, el, prefix, suffix = '', from = 0, withFractions = true) {
        const {gsap} = await import('gsap')

        gsap.to(
            { value: from },
            {
                value: +to,
                duration: .8,
                ease: "power2.inOut",
                onUpdate: function() {
                    if (el){
                        el.textContent = prefix + this.targets()[0].value.toFixed(withFractions ? 2 : 0) + suffix;
                    }
                }
            }
        );
    }

    #addEvents() {
        DOM.addEvent('click', '.share-with-friends', async (event) => {
            event.preventDefault();

            DOM.el('.my_account_hidden_sharer .link.share.qr').click()

        })
    }
}